import { Tag, Typography } from 'antd';

const { Text } = Typography;

type ShiftStatusMap = Record<
  string,
  { readonly element: JSX.Element; readonly isVacant: boolean }
>;

type ShiftStatusTagProps = {
  readonly status: string;
  readonly textColor?: string;
  readonly isStrong?: boolean;
  readonly isItalic?: boolean;
  readonly isDeleted?: boolean;
};

const GenericShiftStatusTag = ({
  status,
  isStrong,
  isItalic,
  isDeleted,
  textColor,
}: ShiftStatusTagProps) => (
  <Tag style={{ width: 'inherit' }}>
    <Text
      strong={isStrong}
      italic={isItalic}
      delete={isDeleted}
      ellipsis={true}
      style={{ color: textColor }}
    >
      {status}
    </Text>
  </Tag>
);

export const shiftStatusMap: ShiftStatusMap = {
  Sourcing: {
    element: <GenericShiftStatusTag status="Sourcing" isItalic />,
    isVacant: true,
  },
  'Unable to fill': {
    element: (
      <GenericShiftStatusTag status="Unable to fill" textColor="red" isStrong />
    ),
    isVacant: true,
  },
  'No Longer required': {
    element: (
      <GenericShiftStatusTag
        status="No Longer required"
        isStrong
        isItalic
        isDeleted
      />
    ),
    isVacant: true,
  },
  Tentative: {
    element: <GenericShiftStatusTag status="Tentative" isItalic />,
    isVacant: false,
  },
  'Stood Down': {
    element: <GenericShiftStatusTag status="Stood Down" isStrong />,
    isVacant: false,
  },
  Confirmed: {
    element: (
      <GenericShiftStatusTag status="Confirmed" textColor="green" isStrong />
    ),
    isVacant: false,
  },
  'Sent to AirOps': {
    element: (
      <GenericShiftStatusTag status="Sent to AirOps" textColor="orange" />
    ),
    isVacant: false,
  },
  'Awaiting Action': {
    element: <GenericShiftStatusTag status="Awaiting Action" />,
    isVacant: false,
  },
  'Awaiting formal request': {
    element: (
      <GenericShiftStatusTag status="Awaiting formal request" isItalic />
    ),
    isVacant: false,
  },
};

export const ShiftStatusTag = ({
  status,
}: {
  readonly status: string;
}): JSX.Element => {
  return shiftStatusMap[status]?.element ?? <></>;
};

export const vacantShiftStatusValues: readonly string[] = Object.keys(
  shiftStatusMap
).filter((status) => shiftStatusMap[status]?.isVacant === true);

export const filledShiftStatusValues: readonly string[] = Object.keys(
  shiftStatusMap
).filter((status) => shiftStatusMap[status]?.isVacant === false);

export const vacantShiftDefaultStatus = 'Sourcing';

export const filledShiftDefaultStatus = 'Awaiting Action';
